import {useIsFetching, useIsMutating} from 'react-query'

export const useIsLoading = () => {
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()

  return isFetching > 0 || isMutating > 0
}
